/* unplugin-vue-components disabled */import script from "./JudgeTableBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./JudgeTableBlock.vue?vue&type=script&setup=true&lang=ts"

import "./JudgeTableBlock.vue?vue&type=style&index=0&id=04ed37e3&scoped=true&lang=less"
import "./JudgeTableBlock.vue?vue&type=style&index=1&id=04ed37e3&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04ed37e3"]])

export default __exports__